import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const state = {
  invoices: [],
  isModalVisible: false,
  amountInvoices: '0.00',
  totalPaid: '0.00'
}

const mutations = {
  SET_RECORDS (state, payload) {
    state.invoices = payload
  },
  ADD_RECORD (state, payload) {
    state['invoices'].unshift(payload)
  },
  DELETE_RECORD (state, payload) {
    const idx = state.invoices.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.invoices, idx)
    }
  },
  UPDATE_RECORD (state, payload) {
    const idx = state['invoices'].findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state['invoices'], idx, payload)
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_AMOUNT_INVOICES (state, payload) {
    state.amountInvoices = payload
  },
  SET_AMOUNT_PAID (state, payload) {
    state.totalPaid = payload
  }
}

const actions = {
  async loadRecords ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.sale_id}/invoices`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadAmountInvoices ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sale/${payload.sale_id}/amount-invoices`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_AMOUNT_INVOICES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addRecord ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`sales/${payload.sale_id}/invoices`, payload.data)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_RECORD', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async updateRecord ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`/sales/${payload.sale_id}/invoices/${payload.invoice_id}`, payload.data)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', payload.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteRecord ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`sales/${payload.sale_id}/invoices/${payload.invoice.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RECORD', payload.invoice)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async totalPaidSale ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sale/${payload.sale_id}/total-paid`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_AMOUNT_PAID', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  loadPayments ({ dispatch }, payload) {
    dispatch('InvoicePayments/loadRecords', payload, { root: true })
  },
  loadAmountPayments ({ dispatch }, payload) {
    dispatch('InvoicePayments/loadAmountPayments', payload, { root: true })
  },
  loadAllPayments ({ dispatch }, payload) {
    dispatch('InvoicePayments/loadAllPayments', payload, { root: true })
  },
  addPayment ({ dispatch }, payload) {
    dispatch('InvoicePayments/addRecord', payload, { root: true })
  },
  deletePayment ({ dispatch }, payload) {
    dispatch('InvoicePayments/deleteRecord', payload, { root: true })
  },
  actionSale ({ dispatch }, payload) {
    dispatch('Sales/actionSale', payload, { root: true })
  }
}

const getters = {
  isModalVisible: state => state.isModalVisible,
  invoices: state => state.invoices,
  amountInvoices: state => state.amountInvoices,
  totalPaid: state => state.totalPaid,
  payments: (state, getters, rootState, rootGetters) => rootGetters['InvoicePayments/payments'],
  amountPayments: (state, getters, rootState, rootGetters) => rootGetters['InvoicePayments/amountPayments']
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
